var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-industry highlight-icon bg-primary p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Allocated Warehouse Space ")]), _vm._v(" "), _c('strong', [_vm._v("10")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-cube highlight-icon bg-success p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Allocated Warehouse Space (In sqft)")]), _vm._v(" "), _c('strong', [_vm._v("4456")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag highlight-icon bg-warning p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Inventory")]), _vm._v(" "), _c('strong', [_vm._v("4417.55 (Cubic Meter)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-truck highlight-icon bg-danger p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Orders Shipped")]), _vm._v(" "), _c('strong', [_vm._v("(In sqft)")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-cart-plus highlight-icon bg-info p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Process Orders")]), _vm._v(" "), _c('strong', [_vm._v("34")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart highlight-icon bg-warning p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Total Sale")]), _vm._v(" "), _c('strong', [_vm._v("370")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold small"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart highlight-icon bg-danger p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Total Sale")]), _vm._v(" "), _c('strong', [_vm._v("99000.00")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold small"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body p-3 d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-rupee highlight-icon bg-success p-3 font-2xl mr-3"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-text text-dark"
  }, [_vm._v("Total Revenue")]), _vm._v(" "), _c('strong', [_vm._v("140500.80")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-uppercase font-weight-bold small"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 mb-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title mb-4"
  }, [_vm._v("Top Selling Product")]), _vm._v(" "), _c('table', {
    staticClass: "table tbl",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Product Name")]), _vm._v(" "), _c('th', [_vm._v("Brand")]), _vm._v(" "), _c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("MRP")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/1111.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Navy Patch Pocket Pants")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("2099.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/1111.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Navy Patch Pocket Pants")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("2099.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/1111.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Blue Washed Casual Jeans")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("2099.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/1111.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Blue Washed Casual Jeans")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("2099.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/gdg234.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Grasshopper Glow In Dark Half Sleeve T-Shirt - Printed")]), _vm._v(" "), _c('td', [_vm._v("Grasshopper Juniors\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("299.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/2222a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Zero Vests Sleeveless - Set Of 3")]), _vm._v(" "), _c('td', [_vm._v("Zero\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("180.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/2222a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Zero Vests Sleeveless - Set Of 3")]), _vm._v(" "), _c('td', [_vm._v("Zero\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("180.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/2222a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Zero Vests Sleeveless - Set Of 3")]), _vm._v(" "), _c('td', [_vm._v("Zero\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("180.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/2222a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Zero Vests Sleeveless - Set Of 3")]), _vm._v(" "), _c('td', [_vm._v("Zero\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("180.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/2222a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Zero Vests Sleeveless - Set Of 3")]), _vm._v(" "), _c('td', [_vm._v("Zero\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("180.00")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 mb-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title mb-4"
  }, [_vm._v("Top Selling Product Brandwise")]), _vm._v(" "), _c('table', {
    staticClass: "table tbl",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Product Name")]), _vm._v(" "), _c('th', [_vm._v("Brand")]), _vm._v(" "), _c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("MRP")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/1111.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Blue Washed Casual Jeans")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("2099.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/1111.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Blue Washed Casual Jeans")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("2099.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/1111.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Navy Patch Pocket Pants")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("2099.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/1111.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Navy Patch Pocket Pants")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Minikid House\n                    ")]), _vm._v(" "), _c('td', [_vm._v("2099.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Lavender Smocked Strappy Bow Dress")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Lavender Smocked Strappy Bow Dress")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Lavender Smocked Strappy Bow Dress")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Smocked Strappy Bow Dress - Orange")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Smocked Strappy Bow Dress - Orange")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])]), _vm._v(" "), _c('tr', {
    staticClass: "table"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Smocked Strappy Bow Dress - Orange")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 mb-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title mb-4"
  }, [_vm._v("Top Selling Product Categorywise")]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', {}, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Product Name")]), _vm._v(" "), _c('th', [_vm._v("Brand")]), _vm._v(" "), _c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("MRP")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/san11.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Doink - Sandals With Floral Applique")]), _vm._v(" "), _c('td', [_vm._v("Doink\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("899.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Smocked Strappy Bow Dress - Orange")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Lavender Smocked Strappy Bow Dress")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Smocked Strappy Bow Dress - Orange")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/32aaa.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("The Red Rose By Chu Jian Ou - LL131037")]), _vm._v(" "), _c('td', [_vm._v("Posterboy\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Home Decor")]), _vm._v(" "), _c('td', [_vm._v("2100.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/2345gdfg.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("CasaMia Air Freshener - Rose")]), _vm._v(" "), _c('td', [_vm._v("CasaMia\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Home Decor")]), _vm._v(" "), _c('td', [_vm._v("129.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/32aaa.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Peaceful Sleep By Chujian Ou - LL131036")]), _vm._v(" "), _c('td', [_vm._v("Posterboy\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Home Decor")]), _vm._v(" "), _c('td', [_vm._v("925.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/dgd2112.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("The Conversation By Pam Powell - LL130127")]), _vm._v(" "), _c('td', [_vm._v("Posterboy\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Home Decor")]), _vm._v(" "), _c('td', [_vm._v("575.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/dgd2112.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Mending The Drift By Dix Baines - LL130539")]), _vm._v(" "), _c('td', [_vm._v("Posterboy\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Home Decor")]), _vm._v(" "), _c('td', [_vm._v("575.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/2345gdfg.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("CasaMia Air Freshener - Alpine")]), _vm._v(" "), _c('td', [_vm._v("CasaMia\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Home Decor")]), _vm._v(" "), _c('td', [_vm._v("129.00")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 mb-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title mb-4"
  }, [_vm._v("Top Selling Product SubCategorywise")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Product Name")]), _vm._v(" "), _c('th', [_vm._v("Brand")]), _vm._v(" "), _c('th', [_vm._v("Sub Category")]), _vm._v(" "), _c('th', [_vm._v("MRP")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/san11.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Doink - Sandals With Floral Applique")]), _vm._v(" "), _c('td', [_vm._v("Doink\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("899.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Lavender Smocked Strappy Bow Dress")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Smocked Strappy Bow Dress - Orange")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/421207a.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Smocked Strappy Bow Dress - Orange")]), _vm._v(" "), _c('td', [_vm._v("Place\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Clothes & Shoes")]), _vm._v(" "), _c('td', [_vm._v("749.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/345aa.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Djeco Princess Marguerite - Bamboo Umbrella")]), _vm._v(" "), _c('td', [_vm._v("Djeco\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Fashion Accessories")]), _vm._v(" "), _c('td', [_vm._v("1699.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/fgd2342.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Palmer's Nursing Cream with Pack of 4 Nursing Pads")]), _vm._v(" "), _c('td', [_vm._v("Palmer's\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Moms & Maternity")]), _vm._v(" "), _c('td', [_vm._v("2701.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/345aa.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Neat-Oh! Dinosaur Carry Case Playmat")]), _vm._v(" "), _c('td', [_vm._v("Neat-Oh!\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Nursery")]), _vm._v(" "), _c('td', [_vm._v("999.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/dgd2112.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("The Conversation By Pam Powell - LL130127")]), _vm._v(" "), _c('td', [_vm._v("Posterboy\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Home Decor")]), _vm._v(" "), _c('td', [_vm._v("575.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/dgd2112.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Scouting The Hatch By Dix Baines - LL130538")]), _vm._v(" "), _c('td', [_vm._v("Posterboy\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Home Decor")]), _vm._v(" "), _c('td', [_vm._v("575.00")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": "static/img/avatars/dgd2112.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Mending The Drift By Dix Baines - LL130539")]), _vm._v(" "), _c('td', [_vm._v("Posterboy\n                    ")]), _vm._v(" "), _c('td', [_vm._v("Home Decor")]), _vm._v(" "), _c('td', [_vm._v("575.00")])])])])])])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1a9407e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/merchantdashboard.vue
// module id = 752
// module chunks = 2